module.exports = __webpack_public_path__ + "static/original-lg-ad8effce45d3c14a655bbb4a14486ca4.jpg";